export default "__VITE_ASSET__BMUVsqAC__"